module.exports = __webpack_public_path__ + "static/media/wagz_logo_new.e408f0f6.svg";